(() => {
  if (window.YesnapResiliaCommerce) return;
  const base = () => window.Shopify?.routes?.root || '/';
  const drawer = () => document.querySelector('#header-component cart-drawer-component') || document.querySelector('cart-drawer-component');
  const sectionIds = () => [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el => el.dataset.sectionId))].slice(0, 5);
  const contextURL = () => { const url = new URL(location.href); url.hash = ''; return url.pathname + url.search; };
  const waitForDrawer = () => Promise.race([customElements.whenDefined('cart-drawer-component'), new Promise((_, reject) => setTimeout(() => reject(Error('Cart drawer is not ready.')), 8000))]);
  async function renderDrawer(result, item) {
    await waitForDrawer();
    const target = drawer();
    if (!target?.open) throw Error('Cart drawer is not available.');
    const current = target.querySelector('cart-items-component');
    const sectionId = current?.dataset.sectionId;
    let markup = result.sections?.[sectionId];
    if (!markup) {
      // Some storefront apps replace bundled section responses with a "product"
      // section. A fresh page response retains the correct preview theme and cart.
      const url = new URL(contextURL(), location.origin);
      if (window.Shopify?.theme?.role === 'unpublished') url.searchParams.set('preview_theme_id', window.Shopify.theme.id);
      url.searchParams.set('_yn_cart', Date.now());
      const response = await fetch(url, {headers:{Accept:'text/html'}, cache:'no-store'});
      if (!response.ok) throw Error('Could not refresh the cart drawer.');
      markup = await response.text();
    }
    const parsed = new DOMParser().parseFromString(markup, 'text/html');
    const nextDrawer = parsed.querySelector('#header-component cart-drawer-component') || parsed.querySelector('cart-drawer-component');
    const next = nextDrawer?.querySelector('cart-items-component');
    if (!current || !next) throw Error('Could not render the cart drawer.');
    const count = [...next.querySelectorAll('input[name="updates[]"]')].reduce((total, input) => total + Number(input.value || 0), 0);
    const component = document.importNode(next, true);
    // Update only the drawer, preserving header refs, menus and the purchase UI.
    current.replaceWith(component);
    const emptyTemplate = nextDrawer.querySelector('#empty-cart-template');
    target.querySelector('#empty-cart-template')?.remove();
    if (emptyTemplate) target.prepend(document.importNode(emptyTemplate, true));
    const dialog = target.querySelector('dialog');
    dialog.classList.toggle('cart-drawer--empty', count === 0);
    const label = nextDrawer.querySelector('dialog')?.getAttribute('aria-labelledby');
    if (label) dialog.setAttribute('aria-labelledby', label);
    component.dispatchEvent(new CustomEvent('cart:update', {bubbles:true, detail:{resource:{item_count:count}, sourceId:String(item.id), data:{source:'yesnap-resilia', itemCount:count, variantId:String(item.id)}}}));
    for (const other of document.querySelectorAll('cart-drawer-component')) if (other !== target && other.querySelector('dialog[open]')) other.close?.();
    target.open();
    if (!target.querySelector('dialog[open]')) throw Error('Cart drawer could not open.');
  }
  let pending = false;
  async function purchase(item, checkout, form) {
    if (pending) throw Error('Please wait for your current request to finish.');
    pending = true;
    try {
      const ids = checkout ? [] : sectionIds();
      const payload = {items:[item], ...(ids.length ? {sections:ids, sections_url:contextURL()} : {})};
      // The custom picker supplies the plan. Appstle's generic interceptor otherwise
      // replaces it with its hidden widget selection (and drops bundled sections).
      const response = await fetch(`${base()}cart/add.js?appstle=true`, {method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify(payload)});
      const result = await response.json();
      if (!response.ok) throw Error(result.description || result.message || 'This item could not be added. Please try again.');
      if (checkout) { window.location.assign(`${base()}checkout`); return {}; }
      try {
        await renderDrawer(result, item, form);
      } catch (error) {
        // An add already succeeded. Retry only rendering, never the POST.
        try { await renderDrawer({}, item, form); }
        catch (refreshError) { console.warn('Yesnap cart drawer refresh:', refreshError); return {warning:'Added to cart. Please open the cart icon to review your items.'}; }
      }
      return {};
    } finally { pending = false; }
  }
  window.addEventListener('pageshow', () => { pending = false; });
  window.YesnapResiliaCommerce = {purchase};
})();
